import React from 'react';
import { useDataProvider, useNotify, useRefresh, useTranslate } from 'react-admin';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import { useNotifyError } from 'utils/notifiers/useNotifyError';
import { AppSecretType } from 'entities/AppSecretType';


export const CreateWebhookSecretButton = ({ oauthClientId }) => {
	const dataProvider = useDataProvider();
	const translate = useTranslate();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const refresh = useRefresh();

	const handleCreate = async () => {
		try {
			await dataProvider.create('app-secrets', {
				data: { oauth2_client_id: oauthClientId, type: AppSecretType.webhook_signing },
			});
			notify(translate('resources.app-secrets.created'), 'info');
			refresh();
		} catch (error) {
			notifyError(error);
		}
	};

	return (
		<Button onClick={handleCreate} variant="outlined" size="small" startIcon={<AddIcon />}>
			{translate('resources.app-secrets.actions.add_webhook_signing')}
		</Button>
	);
};
